import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import getRouterConfig from '../utils/getRouterConfig';

const useScrollToTop = () => {
	const {pathname} = useLocation();

	useEffect(() => {
		if (getRouterConfig(pathname, 'noScroll') !== true) {
			window.scrollTo(0, 0);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	return null;
};

export default useScrollToTop;
